import { useNavigate } from "react-router-dom";
import { PlusCircle, Compass } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import CreatorDashboard from "./CreatorDashboard";
import FreelancerDashboard from "./FreelancerDashboard";

export default function BothDashboard({ d, reload }) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const firstName = (user?.stage_name || "").split(" ")[0] || "";
  return (
    <div className="space-y-8 fade-up" data-testid="both-dashboard">
      <section className="relative overflow-hidden rounded-2xl border border-primary/20 bg-gradient-to-br from-primary/10 via-card to-card p-5 sm:p-8">
        <div className="pointer-events-none absolute -right-12 -top-12 h-48 w-48 rounded-full bg-primary/10 blur-3xl" aria-hidden="true" />
        <div className="relative">
          {firstName && <p className="text-sm text-muted-foreground">Olá, <span className="text-foreground font-semibold">{firstName}</span> 👋</p>}
          <h1 className="font-head text-3xl sm:text-4xl font-extrabold tracking-tight mt-1 leading-tight">
            Seu palco <span className="bg-gradient-to-r from-primary to-amber-400 bg-clip-text text-transparent">completo</span>
          </h1>
          <p className="text-muted-foreground mt-2 text-sm sm:text-base">Crie eventos e encontre oportunidades — tudo num só lugar.</p>
          <div className="flex flex-wrap gap-2 mt-4">
            <Button data-testid="both-cta-create" onClick={() => navigate("/eventos/novo")} className="gap-2"><PlusCircle className="h-5 w-5" />Criar evento</Button>
            <Button data-testid="both-cta-find" onClick={() => navigate("/buscar-eventos")} variant="outline" className="gap-2 border-primary/40 text-primary hover:bg-primary/10 bg-transparent"><Compass className="h-5 w-5" />Encontrar eventos</Button>
          </div>
        </div>
      </section>

      <div>
        <h2 className="font-head text-sm font-bold text-muted-foreground uppercase tracking-[0.18em] mb-4">Como criador</h2>
        <CreatorDashboard d={d} reload={reload} embedded />
      </div>
      <div>
        <h2 className="font-head text-sm font-bold text-muted-foreground uppercase tracking-[0.18em] mb-4">Como músico</h2>
        <FreelancerDashboard d={d} reload={reload} embedded />
      </div>
    </div>
  );
}
